
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17 0a1 1 0 110 2 1 1 0 010-2zm-3 3a1 1 0 011 1h7v2h-1v7.656l6.156 7.938c.543.698.844 1.553.844 2.438a3.978 3.978 0 01-3.969 3.969H7.968a3.978 3.978 0 01-3.969-3.969c0-.885.301-1.74.844-2.438l6.156-7.938V6h-1V4h3a1 1 0 011-1zm-1 3v8.344L10.156 18h11.688L19 14.344V6h-6zm4 4a1 1 0 110 2 1 1 0 010-2zM8.594 20l-2.188 2.813A1.985 1.985 0 006 24.032c0 1.105.864 1.969 1.969 1.969h16.063a1.947 1.947 0 001.969-1.969c0-.439-.137-.873-.406-1.219L23.407 20H8.594z"}})])
          )
        }
      }
    